import {Component, EventEmitter, Input, Output} from "@angular/core";
import {InsuranceProduct} from "../../../models";

@Component({
  selector: "app-insurance-product-list",
  templateUrl: "./insurance-product-list.component.html",
  styleUrls: ["./insurance-product-list.component.scss"]
})
export class InsuranceProductListComponent {
  @Input() insuranceProducts: InsuranceProduct[] = [];
  @Input() activeProductIndex: number;
  @Output() selectProduct: EventEmitter<number> = new EventEmitter<number>();

  onSelectProduct(index: number) {
    this.selectProduct.emit(index);
  }

  isActiveProduct(index: number): boolean {
    return index === this.activeProductIndex;
  }

  noProducts(): boolean {
    return this.insuranceProducts.length === 0;
  }

  sort(insuranceProducts: InsuranceProduct[]) {
    if (!insuranceProducts) {
      return [];
    }
    return insuranceProducts.sort((a, b) => a.name.localeCompare(b.name));
  }
}
